<template>
    <div>
        <van-button @click.stop="openModal" color="#00c8d2" block type="primary">厂区调拨预约</van-button>
        <van-popup close-on-popstate position="right" v-model="visible"
            :style="{ width: '100%', height: '100%', background: '#eeeeee', transform: 'none', top: 0 }"
            get-container="body">
            <div class="appointDiv-modify">
                <van-nav-bar @click-left="visible = false" title="厂区调拨预约">
                    <template #left>
                        <van-icon color="#00C8D2" name="arrow-left" size="20" />
                    </template>
                </van-nav-bar>
                <div class="cont1">
                    <van-cell-group class="requried">
                        <van-field v-model="params.areaValue" label="选择厂区" placeholder="请选择厂区" readonly
                            style="padding: 16px 0px;" />
                    </van-cell-group>
                </div>
                <div class="cont1">
                    <van-cell-group class="requried" style="width: calc(100vh - 34px);">
                        <van-field v-model="params.categoryValue" label="业务大类" placeholder="请选择" right-icon="arrow-down"
                            readonly @click="categoryShow = true" style="padding: 16px 0px;" />
                    </van-cell-group>
                </div>

                <van-action-sheet v-model="categoryShow">
                    <van-picker show-toolbar :columns="categoryColumns" @cancel="onCancel"
                        @confirm="onConfirmCategory" />
                </van-action-sheet>

                <p style="padding: 0 15px;font-weight: bold;">{{ params.categoryValue }}业务</p>

                <div class="cont4">
                    <van-cell-group class="requried">
                        <van-field v-model="params.order_code" label="单据编号" placeholder="请输入单据编号" />
                    </van-cell-group>
                </div>

                <div class="cont4">
                    <van-cell-group class="requried">
                        <van-field v-model="params.delivery_unit" label="收货单位" placeholder="请输入收货单位" />
                    </van-cell-group>
                </div>

                <div class="cont1" v-if="params.areaValue !== ''">
                    <van-cell-group class="requried" style="width: calc(100vh - 34px);">
                        <van-field v-model="params.businessValue" label="选择业务" placeholder="请选择业务"
                            right-icon="arrow-down" readonly @click="businessShow = true" style="padding: 16px 0px;" />
                    </van-cell-group>
                    <!-- :default-index="getDefaultIndex" -->
                </div>

                <!-- 选择业务 -->
                <van-action-sheet v-model="businessShow">
                    <van-picker show-toolbar :columns="businessColumnsComputed" @cancel="onCancel"
                        @confirm="onConfirmBusiness" />
                </van-action-sheet>

                <div class="cont2" style="display: block;" v-if="params.businessValue">
                    <div>
                        涉及{{ businessType === 1 ? "产品线(单选)" : "业务子类(单选)"
                        }}<span style="color: red;">*</span>
                    </div>
                    <div :class="item.selected === true ? 'tabblk-active' : 'tabblk'"
                        v-for="(item, index) in proLineColumms" :key="index" @click="SelectProLine(item, index, 0)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="footer-cont2">
                    <van-button type="primary" block class="btnStyle1" @click.stop="saveAppoint">保存</van-button>
                    <van-button block class="btnStyle2" @click.stop="goBack">取消</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    props: {
        rowDataObj: {
            type: Array,
            default: () => []
        },
        proLineSelect: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            visible: false,
            categoryShow: false,
            businessShow: false,
            params: {
                order_code: "",
                delivery_unit: "",
            },
            businessColumns: [],
            categoryColumns: [
                { text: '装车', id: 1 },
                { text: '卸货', id: 2 }
            ], // 业务大类
            businessType: "",
            proLineColumms: []
        }
    },
    computed: {
        businessColumnsComputed() {
            let arr = []
            for (let i = 0; i < this.businessColumns.length; i++) {
                const business = this.businessColumns[i];
                const sub_buness = business.sub_buness.map((item) => {
                    return {
                        ...item,
                        category: item.category == 0 ? business.category : item.category
                    }
                }).filter((e) => e.category === this.params.category);
                if (sub_buness.length > 0) {
                    arr.push({
                        ...business,
                        sub_buness
                    });
                }
            }
            return arr;
        }
    },
    methods: {
        async openModal() {
            // 获取父级选中的业务线
            const businessId = this.proLineSelect[0].id
            // 根据父级选择的业务线，获取映射的业务线
            const dataObj = await this.$common.http({
                url: "/api/queue/transfer/get_business_mapping?business_id=" + businessId
            })
            // 获取的映射配置
            const mapping = dataObj.data.data;

            if (mapping) {
                // 映射配置里的厂区信息获取
                const fComData = this.rowDataObj.find((e) => e.id === mapping.map_com_id);
                if (fComData) {
                    // 赋值厂区
                    this.params.areaValue = fComData.name;
                    this.params.comId = fComData.id;
                    // 根据配置的子业务线，获取到对应的业务类型
                    const fBusiness = fComData.business.find((e) => {
                        return e.sub_buness.map((s) => s.id).includes(mapping.map_business_id)
                    })
                    if (fBusiness) {
                        // 赋值业务大类
                        this.params.categoryValue = fBusiness.category == 1 ? '装车' : '卸货',
                        this.params.category = fBusiness.category
                        this.handleBusinessColumns()
                        // 手动触发选择业务的确认事件
                        this.onConfirmBusiness(fBusiness)
                        // 找到子业务的内容和下标
                        const fSubBusiness = fBusiness.sub_buness.find((e) => e.id === mapping.map_business_id)
                        const fSubBusinessIndex = fBusiness.sub_buness.findIndex((e) => e.id === mapping.map_business_id)
                        if (fSubBusiness) {
                            // 手动触发子业务线的选中事件
                            this.SelectProLine(fSubBusiness, fSubBusinessIndex, 0)
                        }
                    }
                } else {
                    const mapArea = this.rowDataObj.find((e) => e.id !== this.$route.query.areaId);
                    // 赋值厂区
                    this.params.areaValue = mapArea.name;
                    this.params.comId = mapArea.id;
                }
            }
            this.visible = true
        },
        onCancel() {
            this.categoryShow = false
            this.businessShow = false
        },
        // 确认选择业务大类
        onConfirmCategory(val) {
            this.params.categoryValue = val.text;
            this.params.category = val.id;
            this.initData();
            this.onCancel();
        },
        initData() {
            this.params.order_code = "";
            this.params.delivery_unit = "";
            this.params.businessValue = "";
            this.params.type = "";
            this.businessType = "";
            this.params.businessId = "";
            this.handleBusinessColumns()
        },
        handleBusinessColumns() {
            for (let i = 0; i < this.rowDataObj.length; i++) {
                if (this.params.comId === this.rowDataObj[i].id) {
                    let arr = [];
                    let d_arr = [];
                    this.rowDataObj[i].business.forEach(items => {
                        arr.push({
                            ...items,
                            text: items.name
                        });
                        if (items.category == 2) {
                            d_arr.push({
                                ...items,
                                text: items.name
                            })
                        }
                    });
                    this.businessColumns = arr;
                }
            }
        },
        onConfirmBusiness(val) {
            this.params.businessValue = val.name;
            this.params.type = val.type;
            this.businessType = val.selective_type;
            this.params.businessId = val.id;
            this.businessShow = false;
            // 重置产品线选中
            this.proLineColumms = []; // 产品线列表
            this.params.proLineSelect = []; // 产品线选择清空
            val.sub_buness.forEach(item => {
                this.proLineColumms.push({
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    selective_type: val.selective_type,
                    selected: false
                });
            });
        },

        // 选择产品线
        SelectProLine(item, index, tag) {
            this.params.proLineSelect = [];
            if (Number(tag) === 1) {
                // 多选
                this.proLineColumms[index].selected = !item.selected;
                for (let i = 0; i < this.proLineColumms.length; i++) {
                    if (this.proLineColumms[i].selected) {
                        this.params.proLineSelect.push(this.proLineColumms[i]);
                    }
                }
            } else {
                // 单选
                for (let i = 0; i < this.proLineColumms.length; i++) {
                    this.proLineColumms[i].selected = false;
                }
                this.proLineColumms[index].selected = !item.selected;
                if (this.proLineColumms[index].selected) {
                    this.params.proLineSelect.push(this.proLineColumms[index]);
                }
            }
        },
        saveAppoint() {
            if (!this.params.category) {
                this.$common.mbToastFail("请选择业务大类");
                return false;
            }
            if (this.params.order_code.trim() === "") {
                this.$common.mbToastFail("请输入单据编号");
                return false;
            }
            if (this.params.delivery_unit.trim() === "") {
                this.$common.mbToastFail("请输入收货单位");
                return false;
            }
            if (this.params.businessValue.trim() === "") {
                this.$common.mbToastFail("请选择业务");
                return false;
            }
            if (this.businessType === 1 && this.params.proLineSelect.length === 0) {
                this.$common.mbToastFail("请至少选择一个产品线");
                return false;
            }
            if (this.businessType === 0 && this.params.proLineSelect.length === 0) {
                this.$common.mbToastFail("请选择业务子类");
                return false;
            }
            this.$emit('change', this.getParams());
            this.visible = false;
        },
        goBack() {
            this.visible = false;
            this.initData()
        },
        getParams() {
            return {
                business_id: this.params.businessId,
                business_ids: this.params.proLineSelect.map(e => e.id).join(","),
                com_id: this.params.comId,
                order_code: this.params.order_code,
                delivery_unit: this.params.delivery_unit,
            }
        }
    },
    filters: {}
}
</script>

<style lang="less" scoped>
// .appointTransferModify {
//     width: 90%;
//     right: 5%;
// }
@import "../../assets/css/common";

.appointDiv-modify {
    border-top: 1px solid #f4f5f6;
    background: #f4f5f6;
    font-size: 16px;

    .cont1 {
        line-height: 54px;
        background: #fff;
        display: flex;
        padding: 0px 15px;
        margin-bottom: 10px;

        .left {
            flex: 1;
        }

        .right {
            flex: 0.5;
            text-align: right;
        }
    }

    .cont2 {
        padding: 20px 16px;
        background: #fff;
        margin-bottom: 10px;

        .tabblk-active {
            display: inline-block;
            background: #00c8d2;
            color: #fff;
            margin: 14px 20px 0px 0px;
            padding: 6px 11px;
            border-radius: 20px;
        }

        .tabblk {
            display: inline-block;
            background: #f7f7f7;
            color: #999999;
            margin: 14px 20px 0px 0px;
            padding: 6px 11px;
            border-radius: 20px;
        }
    }

    .cont3 {
        padding: 16px;
        background: #fff;
        margin-bottom: 10px;

        .car-license {
            &-title {
                margin: 4px 0px 20px;
                font-size: 17px;
            }

            &-btn-active {
                display: inline-block;
                background: #00c8d2;
                color: white;
                font-size: 13px;
                padding: 9px 18px;
                border-radius: 4px;
                margin: 0px 14px 24px 0px;
            }

            &-btn {
                display: inline-block;
                background: #f6f6f7;
                color: #00c8d2;
                font-size: 13px;
                padding: 9px 18px;
                border-radius: 4px;
                margin: 0px 14px 24px 0px;
            }
        }
    }

    .cont4 {
        margin-bottom: 10px;
    }

    .cont5 {
        background: #fff;
        margin-bottom: 10px;
        padding: 16px;
        font-size: 18px;
    }

    .cont6 {
        background: #fff;
        padding: 16px 0px;
    }

    .cont7 {
        display: flex;
        justify-content: center;
        font-size: 13px;
        color: #008b5e;
        text-align: center;
        margin-bottom: 10px;

        &>div {
            flex: 1;
        }

        &-btn {
            background: #cce8df;
            border-radius: 4px;
            display: inline-block;
            padding: 7px 21px;
        }
    }
}

.timeDiv {
    height: 100%;
    width: 100%;
    overflow: auto;
    background-color: #f4f5f6;
    font-size: 16px;

    .cont1 {
        line-height: 56px;
        background: #fff;
        display: flex;
        padding: 0px 15px;
        margin-bottom: 10px;
        height: 56px;

        .left {
            flex: 1;

            .inline {
                display: inline-block;
            }
        }

        .right {
            flex: 0.5;
            text-align: right;
            font-size: 20px;
        }
    }

    .cont2 {
        background: #fff;
        display: flex;
        font-size: 18px;
        padding: 16px;
        align-items: center;

        &-first {
            width: calc(100vw - 216px) !important;
            // flex: 1.1 !important;
            text-align: left !important;
        }

        &>div {
            // flex: 1;
            width: 97px;
            text-align: center;
            margin-right: 13px;
        }
    }

    .cont3 {
        background: #fff;
        display: flex;
        padding: 0px 16px 20px;
        align-items: center;
        // line-height: 43px;
        padding: 0px 16px;
        height: 43px;

        &-first {
            flex: 1.1;
            text-align: left !important;
            word-break: break-all;
        }

        &-second {
            color: #ec3f67;
            width: 97px;
            text-align: center;
        }

        &-third {
            color: #008b5e;
            width: 97px;
            text-align: center;
        }

        &-forth {
            width: 16px;
            text-align: center;
        }
    }

    .pd40 {
        padding-bottom: 36px;
    }

    .bg456 {
        background: #f7f7f7;
    }

    .calendar-cont {
        height: 36px;
        font-size: 14px;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        color: #009967;
        background: #f7f7f7;
        box-shadow: 0px 2px 20px rgba(125, 126, 128, 0.16);
    }

    .mid-cont {
        background: #fff;
        margin-top: 10px;
        padding: 16px;
        font-size: 18px;
        color: #000000;
        line-height: 18px;
    }
}

.mainDiv {
    background: #fff;
}
</style>